import { FC, useState } from 'react';
import { ForgetPasswordType } from './ForgotPasswordType/ForgetPasswordType';
import { LoginType } from './LoginType/LoginType';
import styles from './RegisterModal.module.scss';
import { SignUpType } from './SignUpType/SignUpType';

interface RegisterModalProps {
  redirectUrl?: string;
}

enum AuthStep {
  Login = 1,
  Signup = 2,
  ResetPassword = 3,
}

export const RegisterModal: FC<RegisterModalProps> = ({ redirectUrl }) => {
  const [step, setStep] = useState(AuthStep.Login);

  const goToLogin = () => setStep(AuthStep.Login);
  const goToSignup = () => setStep(AuthStep.Signup);
  const goToResetPassword = () => setStep(AuthStep.ResetPassword);

  const stepMapper: { [key: number]: JSX.Element } = {
    1: (
      <LoginType
        redirectUrl={redirectUrl}
        goToSignup={goToSignup}
        goToResetPassword={goToResetPassword}
      />
    ),
    2: <SignUpType redirectUrl={redirectUrl} goToLogin={goToLogin} />,
    3: <ForgetPasswordType goToLogin={goToLogin} />,
  };

  return <div className={styles.container}>{stepMapper[step]}</div>;
};
